import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    data: Array
  }

  connect() {
    console.log("Seller Invoices Chart Controller connected")
    
    // Check if Chart.js is loaded
    if (typeof Chart === 'undefined') {
      console.error("Chart.js is not loaded!")
      return
    }
    
    if (this.hasDataValue) {
      // Add a small delay to ensure DOM is ready
      setTimeout(() => this.initializeChart(), 300)
    } else {
      console.error("Missing chart data values")
    }
  }

  initializeChart() {
    const ctx = document.getElementById('sellerInvoicesChart')
    if (!ctx) {
      console.error("Canvas element not found")
      return
    }
    
    const chartData = this.dataValue
    
    try {
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: chartData.map(item => item.name.charAt(0).toUpperCase() + item.name.slice(1)),
          datasets: [
            {
              label: 'Facturas Abiertas',
              data: chartData.map(item => item.open_invoices),
              backgroundColor: 'rgba(191, 23, 36, 0.7)',
              borderColor: 'rgba(191, 23, 36, 1)',
              borderWidth: 1
            },
            {
              label: 'Facturas Cerradas',
              data: chartData.map(item => item.closed_invoices),
              backgroundColor: 'rgba(69, 123, 157, 0.7)',
              borderColor: 'rgba(69, 123, 157, 1)',
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom'
            }
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true,
              beginAtZero: true
            }
          }
        }
      })
      console.log("Seller Invoices Chart created successfully")
    } catch (error) {
      console.error("Error creating chart:", error)
    }
  }
}
